import { SVGProps } from 'react';

const MetropolisMap = (props: SVGProps<SVGSVGElement>) => (
  <svg width="80" height="90" viewBox="0 0 80 90" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M71.9837 85.0001H8.37543C4.70377 85.0001 2.44647 80.9826 4.35613 77.8467L12.9531 63.729C13.8072 62.3266 15.3304 61.4707 16.9724 61.4707H64.1031C65.8087 61.4707 67.3808 62.3936 68.2122 63.8829L76.0928 78.0005C77.8437 81.1373 75.5761 85.0001 71.9837 85.0001Z"
      fill="white"
      stroke="#474C53"
      strokeWidth="3"
    />
    <path d="M14.1177 85.0001L24.7059 61.4707" stroke="#474C53" strokeWidth="2" />
    <path d="M5 77.5H75" stroke="#474C53" strokeWidth="2" />
    <path d="M51.7648 85.0001L48.2354 61.4707" stroke="#474C53" strokeWidth="2" />
    <path d="M49.4116 67.3525H69.4116" stroke="#474C53" strokeWidth="2" />
    <path
      d="M40 6.5C55.1993 6.5 67.5 18.7197 67.5 33.7676C67.4999 37.4113 66.2566 41.334 64.1777 45.3457C62.1036 49.3482 59.2436 53.3517 56.1201 57.1318C50.4026 64.0514 43.9441 70.0677 40 73.9023C36.0559 70.0677 29.5974 64.0514 23.8799 57.1318C20.7564 53.3517 17.8964 49.3482 15.8223 45.3457C13.7434 41.334 12.5001 37.4113 12.5 33.7676C12.5 18.7197 24.8008 6.5 40 6.5Z"
      fill="white"
      stroke="white"
      strokeWidth="3"
    />
    <path
      d="M40.1211 11.166C53.1663 11.1662 63.7412 21.7419 63.7412 34.7871C63.7411 37.93 62.6769 41.3262 60.8838 44.8145C59.0953 48.2937 56.6264 51.7784 53.9258 55.0732C49.0495 61.0224 43.5519 66.202 40.1201 69.5596C36.6883 66.2019 31.1915 61.0221 26.3154 55.0732C23.6148 51.7783 21.1459 48.2937 19.3574 44.8145C17.5643 41.3262 16.5001 37.93 16.5 34.7871C16.5 21.7418 27.0757 11.166 40.1211 11.166Z"
      fill="white"
      stroke="#474C53"
      strokeWidth="3"
    />
    <path
      d="M53.8291 35.8223L52.5986 37.0703L48.5254 32.9395L47.0986 31.4932V42.167H45.5029V31.4893L44.0762 32.9365L39.998 37.0723L35.9238 32.9404L34.4971 31.4922V42.167H32.9014V31.4893L31.4746 32.9365L27.3984 37.0703L26.1699 35.8232L33.6973 28.1865L39.4062 33.9766L40 34.5781L40.5938 33.9766L46.2998 28.1865L53.8291 35.8223Z"
      fill="#505780"
      stroke="#302AD8"
      strokeWidth="1.66667"
    />
  </svg>
);

export default MetropolisMap;
